module.exports = __webpack_public_path__ + "media/images/etyekilogo-apple-120x120-4421fc9695efb1880b4ff028edb609e0.png";